/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/Demands/DemandTracker" />
import { DemandType } from "Widgets/Demands/DemandType";

/** Handles internal bookkeeping for tracking demands issued to a demand handler  */
export class DemandTracker {
    private demands: DemandType[];

    constructor() {
        this.reset();
    }
    /** Adds a new demand for tracking.
     * Currently, we do not have need for distinguishing between multiple demands of the same type. Once we do, this call would need to operate against a tuple form object.
     */
    public registerDemand(demand: DemandType): void {
        if (!this.isDemandPresent(demand)) {
            this.demands.push(demand);
        }
    }

    /** get the currently tracked demands. */
    public getDemands(): DemandType[] {
        return this.demands.slice();
    }

    public isDemandPresent(demand: DemandType): boolean {
        return this.demands.indexOf(demand) >= 0;
    }

    /** reset the demands set. */
    public reset(): void {
        this.demands = [];
    }
}
